import { FilteredPageQuery } from './filtered-page-query';

export class TaskPageQuery extends FilteredPageQuery {}
